import React from "react";
import {connect} from "react-redux";
import {Breadcrumb, Row, Col, FormGroup, FormControl, ControlLabel, Checkbox, Button, PanelGroup, Panel} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import HelpHintButton from "components/HelpHintButton";
import locale from "locale";
import {debounce} from "throttle-debounce";
import "./style.less";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import PanelBody from "react-bootstrap/lib/PanelBody";
import { getClientFields } from "../../../../api/cp/clientRegistrationFields";

class PlayerPreview extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.handlers = {
			setHeight: (height) => {
				this.frame.style.height = height + 'px';
				this.frame.style.minWidth = '100%';
				this.frame.style.width = '100px';
			},
			embedCheck: () => {
				this.postMessage('embedConfirm', true);
				this.sendStyle(this.props.theme);
			}
		};

		this.handleMessage = this.handleMessage.bind(this);
		this.sendStyle = debounce(1000, false, this.sendStyle.bind(this));
	}

	handleMessage(e) {
		try {
			const data = JSON.parse(e.data);
			Object.keys(data).forEach(key => {
				if(this.handlers[key]) {
					this.handlers[key](data[key]);
				} else {
					console.warn('Unhandled Message', key);
				}
			});
		} catch(e) {
			console.error(e);
		}
	}
	postMessage(type, data) {
		this.frame.contentWindow.postMessage(JSON.stringify({[type]: data}), '*');
	}

	sendStyle(theme) {
		const {event} = this.props;

		const style = {};
		Object.keys(event.moduleTheme)
			.filter(key => key.match(/Color$/))
			.forEach(key => style[key] = (theme[key] || event.moduleTheme[key]).replace('#', ''))
		;

		this.postMessage('style', style);
	}

	componentDidMount() {
		window.addEventListener('message', this.handleMessage, false);
	}
	componentWillUnmount() {
		window.removeEventListener('message', this.handleMessage);
	}

	UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
		this.sendStyle(nextProps.theme);
	}

	render() {
		const {event, autoplay, hideFooter, lang} = this.props;

		let query = {
			autoplay,
			hideFooter,
			lang
		};

		query = Object.keys(query)
			.filter(function(name) { return query[name]; })
			.map(function(name) { return name + '=' + query[name]; })
			.join('&')
		;

		const src = `/player/${event.eventKey}?${query}`;

		return <iframe src={src} width="100%" height="600" frameBorder="0" scrolling="no" allowFullScreen={true} ref={ref => this.frame = ref} />;
	}
}

class EventEmbedCode extends React.Component {

	state = {
		hideBottomModules: false,
		language: null,
		disableAuthPlay: false,
		themeEnabled: false,
		theme: {
			accentColor: '',
			textColor: '',
			backgroundColor: '',
			borderColor: '',
			playerTextColor: '',
			playerBackgroundColor: '',
//			timeLineEpisodeColor: '',
			inactiveColor: '',
			episodeTextColor: '',
			episodeBackgroundColor: '',
		},
	};

	constructor(props, context) {
		super(props, context);

		Object.keys(this.state.theme).forEach(name => {
			this.state.theme[name] = '#' + this.props.event.moduleTheme[name];
		});

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeThemeColor = this.handleChangeThemeColor.bind(this);
		this.handleChangePlayerTheme = this.handleChangePlayerTheme.bind(this);
		this.resetTheme = this.resetTheme.bind(this);
	}

	handleChange(event) {
		let name = event.target.name;
		let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
		let state = {};
		state[name] = value;
		this.setState(state);
	}
	handleChangeThemeColor(name, value) {
		let theme = Object.assign({}, this.state.theme, {[name]: value});

		this.setState({theme});
	}
	handleChangePlayerTheme(event) {
		let theme = {
			playerBackgroundColor: '',
			playerTextColor: ''
		};
		switch(event.target.value) {
			case 'light':
				theme.playerBackgroundColor = '#FFFFFF';
				theme.playerTextColor = '#000000';
				break;
			case 'dark':
				theme.playerBackgroundColor = '#000000';
				theme.playerTextColor = '#FFFFFF';
				break;
		}
		this.setState({theme: Object.assign({}, this.state.theme, theme)});
	}
	resetTheme() {
		let theme = {};
		Object.keys(this.state.theme).forEach(name => theme[name] = `#${this.props.event.moduleTheme[name]}`);
		this.setState({theme});
	}

	render() {
		const {event} = this.props;

		const attributes = {
			src: `https://${location.host}/player/js/embed.min.js`,
			'data-eventKey': event.eventKey
		};
		const frame_theme = {};

		let changedThemeColors = Object.keys(this.state.theme)
			.filter(name => this.state.theme[name])
			.filter(name => this.state.theme[name] !== '#' + this.props.event.moduleTheme[name])
		;
		if(changedThemeColors.length) {
			changedThemeColors.forEach(name => {attributes[`data-${name}`] = frame_theme[name] = this.state.theme[name];});
		}

		if(this.state.language) {
			attributes['lang'] = this.state.language;
		}
		if(this.state.hideBottomModules) {
			attributes['data-footer'] = false;
		}
		if(this.state.disableAuthPlay) {
			attributes['data-autoplay'] = false;
		}

		const themeColorTitle = {
			accentColor: 'Акцентный цвет',
			textColor: 'Цвет текста',
			backgroundColor: 'Цвет фона',
			borderColor: 'Цвет границ',
//			playerTextColor: 'Цвет текста в плеере',
//			playerBackgroundColor: 'Цвет элементов плеера',
//			timeLineEpisodeColor: '',
			inactiveColor: 'Цвет неактивного элемента',
			episodeTextColor: 'Цвет текста эпизода',
			episodeBackgroundColor: 'Цвет фона эпизода',
		};

		return (
			<section>
				<Breadcrumb>
					<LinkContainer to={`/event/${event.eventPassword}`}>
						<Breadcrumb.Item>
							{locale('mainMenu.widgets')}
						</Breadcrumb.Item>
					</LinkContainer>
					<Breadcrumb.Item active> 
						{locale('mainMenu.widget.player')}
					</Breadcrumb.Item>
				</Breadcrumb>
				<Row>
					<Col xs={4}>
						<p>Настройки кода встраивания</p>
						<FormGroup controlId="embed-code-language-select">
							<ControlLabel>Язык интерфейса
								<HelpHintButton>Язык интерфейса плеера выбирается автоматически исходя из настроек браузера. Так-же язык можно задать принудительно.</HelpHintButton>
							</ControlLabel>
							<FormControl componentClass="select" name="language" onChange={this.handleChange}>
								<option value="">Авто</option>
								<option value="ru">Русский</option>
								<option value="en">Английский</option>
							</FormControl>
						</FormGroup>

						<FormGroup>
							<Checkbox inline name="hideBottomModules" onChange={this.handleChange}>Скрыть нижний блок
								<HelpHintButton>Под плеером могут быть расположены дополнительные модули. Данная опция принудительно скрывает все нижние модули.</HelpHintButton>
							</Checkbox>
						</FormGroup>

						<FormGroup>
							<ControlLabel>
								<span>Цветовая схема
									<HelpHintButton>Цвета элементов оформления плеера</HelpHintButton>
								</span>
								{changedThemeColors.length > 0 && <Button bsStyle="link" bsSize="small" onClick={this.resetTheme}>Сбросить</Button>}
							</ControlLabel>
							<div>
								<FormControl componentClass="select" name="playerTheme" onChange={this.handleChangePlayerTheme}>
									<option>Не менять</option>
									<option value="dark">Тёмная</option>
									<option value="light">Светлая</option>
								</FormControl>
							</div>
							{Object.keys(themeColorTitle).map(name =>
								<div key={name}>
									<input
										type="color"
										value={this.state.theme[name]}
										onChange={(e) => this.handleChangeThemeColor(name, e.target.value)}
									/>
									{' '}
									<span>{themeColorTitle[name]}</span>
								</div>
							)}

						</FormGroup>
					</Col>
					<Col xs={8}>
						<PanelGroup
							accordion
							id="embed-code"
						>
							<Panel eventKey="player-code">
								<PanelHeading>
									<PanelTitle toggle>
										Код для встраивания плеера
									</PanelTitle>
								</PanelHeading>
								<PanelBody collapsible>
									<pre>
										&lt;script {Object.keys(attributes).map(function(name) { return name+'="'+attributes[name]+'"'; }).join('\r\n\t')}&gt;&lt;/script&gt;
									</pre>
								</PanelBody>
							</Panel>
							{event.moduleAuth.guest && (
								<Panel eventKey="integration-code">
									<PanelHeading>
										<PanelTitle toggle>
											Код для интеграции плеера с сайтом
										</PanelTitle>
									</PanelHeading>
									<PanelBody collapsible>
										<pre style={{ whiteSpace: "initial" }}>
											&lt;?php
											<br />
											$eventKey = "{event.eventKey}"; // Уникальный ключ трансляции
											<br />
											$userName = "..."; // Имя пользователя
											<br />
											{!!event.registrationFields.length && (
												<>
													$userRegistrationData = &#91;
													<br />
													{event.registrationFields.map(({field}) => (
														<span key={field.name}>
															&emsp;"{field.name}" =&gt; "...", // {field.label_ru}
															<br />
														</span>
													))}
													&#93;;
													<br />
												</>
											)}
											?&gt;
											<br />
											&lt;script src="https://broadcast.comdi.com/player/js/embed.min.js"
											type="text/javascript"
											data-comdi-event="&lt;?=$eventKey?&gt;"
											data-login="&lt;?php=$userName?&gt;"
											data-registration="&lt;?php=htmlspecialchars(json_encode($userRegistrationData), ENT_QUOTES)?&gt;"
											<br />
											&gt;&lt;/script&gt;
										</pre>
									</PanelBody>
								</Panel>
							)}
						</PanelGroup>

						<p>Пример интеграции плеера с выбранными настройками</p>

						<PlayerPreview event={event}
							autoplay={!this.state.disableAuthPlay}
							hideFooter={this.state.hideBottomModules}
							lang={this.state.language}
							theme={frame_theme} />
						{/*<iframe src={`/embed/${event.eventKey}?${iframe_code_params.join('&')}`} width={800} height={800} frameBorder={0} />*/}
					</Col>
				</Row>
			</section>
		);
	}

}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(EventEmbedCode);
